import { render, staticRenderFns } from "./TrainingDescription.vue?vue&type=template&id=d21e0c42&"
import script from "./TrainingDescription.vue?vue&type=script&lang=js&"
export * from "./TrainingDescription.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDescription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports